import React from 'react';
import * as helpers from './helpers';

const TaskHandlerIcon = ({
  fillOpacity,
  clipRule,
  color,
  backgroundColor,
  fillRule,
  ...props
}) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path opacity={fillOpacity} fillRule={fillRule} clipRule={clipRule} d="M16 0L4 -2.90192e-07C1.79086 -3.43614e-07 8.12177e-07 1.79086 6.37632e-07 4L-3.89507e-07 17C-5.64052e-07 19.2091 1.79086 21 4 21L16 21L16 0Z" fill={backgroundColor} />
    <path opacity={fillOpacity} fillRule={fillRule} clipRule={clipRule} d="M5 7.58248L5 5L7.5 5L7.5 7.58248L5 7.58248ZM5 9.45624L5 12.0387L7.5 12.0387L7.5 9.45624L5 9.45624ZM5 13.9125L5 16.495L7.5 16.495L7.5 13.9125L5 13.9125Z" fill={color} />
    <path opacity={fillOpacity} fillRule={fillRule} clipRule={clipRule} d="M9 7.58248L9 5L11.5 5L11.5 7.58248L9 7.58248ZM9 9.45624L9 12.0387L11.5 12.0387L11.5 9.45624L9 9.45624ZM9 13.9125L9 16.495L11.5 16.495L11.5 13.9125L9 13.9125Z" fill={color} />
  </svg>
);

TaskHandlerIcon.propTypes = {
  ...helpers.iconDimensionsPropTypes,
};

TaskHandlerIcon.defaultProps = {
  fillRule: 'evenodd',
  clipRule: 'evenodd',
  color: '#97A3B4',
  backgroundColor: '#E9EBF2',
  fillOpacity: 1,
  ...helpers.getDefaultIconDimensionsProps(16, 21),
};

export default TaskHandlerIcon;





// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/task-handler.js